import { destroyComplete } from '../../actions/completions/DestroyComplete';
import { kind as restart } from '../../actions/goals/Restart';
import { kind as start } from '../../actions/goals/Start';
import { Database } from '../../Database';
import { reject } from '../../GoalResolvers';
import { State } from '../../State';
import { Task } from '../../Task';
import { initialize } from './initialize';
import { notIdle } from './notIdle';
import { suspend } from './suspend';

export const kind = 'Destroy';

export function destroyTask(database: Database): Task {
  return {
    kind,
    start: async dispatch => {
      await database.close();
      await database.remove();
      dispatch(destroyComplete);
    },
  };
}

export function destroy(state: State): State {
  let goalResolvers = state.goalResolvers;
  const reason = 'Destroying';
  goalResolvers = reject(goalResolvers, start, reason);
  goalResolvers = reject(goalResolvers, restart, reason);

  if (!state.database) {
    // If we don't have a database, initialize it so that we can `destroy` it.
    return initialize({ ...state, goalResolvers });
  }

  if (state.replication) {
    return suspend({ ...state, goalResolvers });
  }

  return {
    ...state,
    goalResolvers,
    nextTask: destroyTask(state.database),
    whenIdle: notIdle(state),
  };
}
